import {
  Actionsheet,
  ActionsheetBackdrop,
  ActionsheetContent,
  ActionsheetDragIndicator,
  ActionsheetDragIndicatorWrapper,
  ActionsheetIcon,
  ActionsheetItem,
  ActionsheetItemText,
} from "@/components/ui/actionsheet";
import { WalletDTO } from "@/generated/api/models";
import { InterfaceActionsheetProps } from "@gluestack-ui/actionsheet/lib/types";
import { Edit, Send, Trash } from "lucide-react-native";
import {
  RestaurantWalletModalDelete,
  RestaurantWalletModalEdit,
} from "./restaurant.wallet.modal";
import { useState } from "react";
import { RestaurantWalletTransferModal } from "./restaurant.wallet.transfer.modal";

export function RestaurantWalletActionSheet({
  organizationId,
  wallet,
  onClose,
  ...rest
}: InterfaceActionsheetProps & {
  organizationId: string;
  wallet: WalletDTO | undefined;
}) {
  const [editIsOpened, setEditIsOpened] = useState(false);
  const [deleteIsOpened, setDeleteIsOpened] = useState(false);
  const [transferIsOpened, setTransferIsOpened] = useState(false);

  return (
    <>
      {wallet && (
        <>
          <RestaurantWalletModalEdit
            organizationId={organizationId}
            wallet={wallet}
            isOpen={editIsOpened}
            onClose={() => setEditIsOpened(false)}
          />
          <RestaurantWalletModalDelete
            organizationId={organizationId}
            wallet={wallet}
            isOpen={deleteIsOpened}
            onClose={() => setDeleteIsOpened(false)}
          />
          <RestaurantWalletTransferModal
            organizationId={organizationId}
            wallet={wallet}
            isOpen={transferIsOpened}
            onClose={() => setTransferIsOpened(false)}
          />
        </>
      )}
      <Actionsheet closeOnOverlayClick onClose={onClose} {...rest}>
        <ActionsheetBackdrop />
        <ActionsheetContent>
          <ActionsheetDragIndicatorWrapper>
            <ActionsheetDragIndicator />
          </ActionsheetDragIndicatorWrapper>
          <ActionsheetItem onPress={() => {
              onClose?.();
              setTransferIsOpened(true);
            }}>
            <ActionsheetIcon className="stroke-background-700" as={Send} />
            <ActionsheetItemText>Transfer</ActionsheetItemText>
          </ActionsheetItem>
          <ActionsheetItem
            onPress={() => {
              onClose?.();
              setEditIsOpened(true);
            }}
          >
            <ActionsheetIcon className="stroke-background-700" as={Edit} />
            <ActionsheetItemText>Rename wallet</ActionsheetItemText>
          </ActionsheetItem>
          <ActionsheetItem
            onPress={() => {
              onClose?.();
              setDeleteIsOpened(true);
            }}
          >
            <ActionsheetIcon className="stroke-background-700" as={Trash} />
            <ActionsheetItemText className="text-red-500">
              Delete
            </ActionsheetItemText>
          </ActionsheetItem>
        </ActionsheetContent>
      </Actionsheet>
    </>
  );
}
